export default function ReadingTime({content}){

    const text = content?.replace(/<[^>]*>/g,"") || ""

    const words = text.split(" ").length

    const readingTime = Math.ceil(words / 200)

    return(

        <span>
            {readingTime} min read
        </span>

    )

}